import React from "react";
import styles from "./WithLoader.less";
import { Loader } from "../Loader";
export function WithLoader(props) {
  return props.condition ? props.children : React.createElement("section", {
    className: styles.Loading,
    style: {
      height: props.height,
      width: props.width
    }
  }, React.createElement("h3", {
    className: styles.Display
  }, props.message), React.createElement(Loader, null));
}